import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
} from '@material-ui/core';
import { FieldTitle } from 'react-admin';

export const RadioButtonGroup: any = ({
  choices,
  onChange,
  value,
  resource,
  source,
  disabled,
}) => {
  return (
    <FormControl component="fieldset" disabled={disabled}>
      <FormLabel component="legend">
        <FieldTitle label="" source={source} resource={resource} />
      </FormLabel>

      <RadioGroup
        value={value}
        style={{ display: 'flex', flexDirection: 'row' }}
      >
        {choices.map(choice => (
          <FormControlLabel
            key={choice.label}
            label={choice.label}
            control={
              <Radio
                value={choice.id}
                color="primary"
                onChange={() => onChange?.(choice.id)}
              />
            }
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
};
